import whitelabelApi from '../http/whitelabelApi'

type WhitelabelLoginBody = {
  code: string
}

type WhitelabelLoginResponse = {
  url: string
}

export const Login = async ({ code }: WhitelabelLoginBody) => {
  const { data } = await whitelabelApi
    .get<WhitelabelLoginResponse>(`/projects/${code}/access`)
    .catch((error) => {
      throw error?.response?.data || error
    })

  return data
}
